import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const InterestIcon = (props: any) => (
  <Svg width={20} height={20} fill= {'none'} {...props}>
    <Path
      stroke={props.active?"rgba(192, 164, 111, 1)":"white"}
      strokeLinecap="round"
      d="M10.083 19c2.396-1.034 7.486-4.51 8.679-10.135 1.491-7.033-4.34-9.653-8.679-6.619-4.34 3.034-1.966 11.997 3.12 14.548"
    />
    <Path
      stroke={props.active?"rgba(192, 164, 111, 1)":"white"}
      strokeLinecap="round"
      d="M10.095 19C7.652 17.966 2.46 14.49 1.243 8.865-.278 1.832 5.669-.788 10.095 2.246c4.426 3.034 2.006 11.997-3.181 14.548"
    />
  </Svg>
);
export default InterestIcon;
